<div #chartContainer>
    <ui-figure-caption>
        <ui-figure-text>
            <h4>{{ diagramBeskrivning$ | async }}</h4>
        </ui-figure-text>
    </ui-figure-caption>
    <app-google-combochart [data]="data" [options]="options" [chartName]="chartName"></app-google-combochart>
    <ui-error-margin />
</div>
